import { css } from '@emotion/core';

export const searchResultsNoResultsFoundCSS = ({ colors }) => css`
    font-style: italic;
    padding: 0.75rem 1rem;
    color: ${colors.textSecondary};
`;

export const searchResultLinkOverrideCSS = ({ colors }) => css`
    width: 100%;
    color: ${colors.black};
    padding: 0.75rem 1rem;
`;

export const searchResultsBrowserAllAppFamiliesCSS = ({ colors }) => css`
    padding: 0.75rem 1rem;
    width: 100%;

    color: black;

    &:active,
    &:focus {
        background-color: ${colors.neutral95};
    }
`;
